import React from "react";
import { motion, AnimatePresence } from "framer-motion";

export const PhoneMockup = ({ currentScreen, className = "" }) => {
  return (
    <div className={`relative mx-auto w-full max-w-[320px] aspect-[9/19.5] bg-black rounded-[3rem] border-[8px] border-black shadow-2xl overflow-hidden ${className}`}>
      {/* Notch */}
      <div className="absolute top-0 inset-x-0 h-7 bg-black z-50 rounded-b-3xl mx-auto w-1/2 flex justify-center items-end pb-1">
        <div className="w-12 h-1.5 bg-neutral-800 rounded-full"></div>
      </div>
      
      {/* Screen Container */}
      <div className="relative w-full h-full bg-white overflow-hidden rounded-[2.5rem]">
        <AnimatePresence mode="wait">
          <motion.div
            key={currentScreen}
            initial={{ opacity: 0, scale: 1.05 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            transition={{ duration: 0.4, ease: "easeInOut" }}
            className="w-full h-full"
          >
            <img 
              src={currentScreen} 
              alt="App Screen" 
              className="w-full h-full object-cover"
            />
          </motion.div>
        </AnimatePresence>
      </div>

      {/* Side Buttons */}
      <div className="absolute -left-[10px] top-24 w-1 h-12 bg-neutral-800 rounded-l-md"></div>
      <div className="absolute -left-[10px] top-40 w-1 h-12 bg-neutral-800 rounded-l-md"></div>
      <div className="absolute -right-[10px] top-32 w-1 h-16 bg-neutral-800 rounded-r-md"></div>
    </div>
  );
};
